var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "30%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-institution-integration-item", {
                          attrs: {
                            model: _vm.model.integration_item_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.integration_item_id,
                            label: "Tipo de Integração",
                            "auto-complete": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "integration_item_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-integration-schedule-type", {
                          attrs: {
                            model: _vm.model.schedule_type_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.schedule_type_id,
                            label: "Tipo de Agendamento",
                            ids: "2,3",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "schedule_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("emc-calendar-date-picker2", {
                          attrs: {
                            model: _vm.model.date_start,
                            label: "Início*",
                            errorMessages: _vm.errors.date_start,
                            show: _vm.dialog,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "date_start", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("emc-calendar-date-picker2", {
                          attrs: {
                            model: _vm.model.date_end,
                            label: "Fim*",
                            errorMessages: _vm.errors.date_end,
                            show: _vm.dialog,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "date_end", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("emc-calendar-time-picker", {
                          attrs: {
                            time: _vm.model.time,
                            error: !!_vm.errors.time,
                            errors: _vm.errors.time,
                            label: _vm.labelTime,
                          },
                          on: {
                            "update:time": function ($event) {
                              return _vm.$set(_vm.model, "time", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: { inset: "", label: "Múltiplos lotes" },
                          model: {
                            value: _vm.model.multi_lot,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "multi_lot", $$v)
                            },
                            expression: "model.multi_lot",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: { inset: "", label: "Ativo" },
                          model: {
                            value: _vm.model.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "active", $$v)
                            },
                            expression: "model.active",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }